














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getIdFromURL } from 'vue-youtube-embed';
import { State, Mutation } from 'vuex-class';
import { Channel } from '../interfaces';
import YoutubeChannelProfile from '@/components/YoutubeChannelProfile.vue';
import YoutubeVideo from '@/components/YoutubeVideo.vue';
import ChannelStats from '@/components/ChannelStats.vue';
import ChannelTags from '@/components/ChannelTags.vue';
import ChannelDescription from '@/components/ChannelDescription.vue';

@Component({
  components: {
    YoutubeChannelProfile,
    YoutubeVideo,
    ChannelStats,
    ChannelTags,
    ChannelDescription,
  },
})
export default class YoutubeChannel extends Vue {
  @State('channels') private stateChannels!: Channel[];
  @State('parent') private parent: any;
  @Mutation('setSubject') private setSubject: any;

  private channel: Channel | null = null;

  public async mounted() {
    this.getChannel(this.$route.params.name);
    this.setStoreSubject();
  }

  @Watch('$route')
  private onRouteChanged(val: string, oldVal: string) {
    this.getChannel(this.$route.params.name);
    this.setStoreSubject();
  }

  @Watch('stateChannels')
  private updateChannels(val: any, oldVal: any) {
    this.getChannel(this.$route.params.name);
  }

  get creationDate(): string {
    if (this.channel) {
      const regex = /\d{4}-\d{2}-\d{2}/g;
      const date = regex.exec(this.channel.publishedAt);
      return date ? new Date(date[0]).toLocaleDateString('fr-FR') : '';
    }
    return '';
  }

  private getChannel(name: string) {
    if (this.stateChannels) {
      this.stateChannels.forEach((channel) => {
        if (channel.name && channel.name.includes('+') && channel.name === name) {
          this.channel = channel;
        } else if (channel.name && channel.name === name.replace(/\+/g, ' ')) {
          this.channel = channel;
        }
      });
    }
  }

  private setStoreSubject() {
    if (this.channel && this.parent !== 'ChannelsSuggestion') {
      this.setSubject(this.channel.subject);
    } else {
      this.setSubject('suggestions');
    }
  }

  private getVideoId(url: string) {
    return getIdFromURL(url);
  }
}
